import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem } from "reactstrap";
import { PRIVACY_POLICY_URL, TERMS_URL, WEB_PAGE_URL } from "../../Constants";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className='app-footer text-black-50'>
        <div className='app-footer--first'>
          <Nav>
            <NavItem>
              <a href={WEB_PAGE_URL} target='_blank' rel='noopener noreferrer'>
                <span className='rounded-sm px-5'>{t("redpay-home")}</span>
              </a>
            </NavItem>
            <NavItem>
              <a href={TERMS_URL} target='_blank' rel='noopener noreferrer'>
                <span className='rounded-sm px-5'>{t("tos")}</span>
              </a>
            </NavItem>
            <NavItem>
              <a href={PRIVACY_POLICY_URL} target='_blank' rel='noopener noreferrer'>
                <span className='rounded-sm px-5'>{t("privacy-policy")}</span>
              </a>
            </NavItem>
          </Nav>
        </div>

        <div className='app-footer--second py-1'>
          <span>{t("fotter-title")}</span> {t("fotter-crafted")} <span className='text-danger px-1'>❤</span>
          {t("by") + " "}
          <a href='https://www.archforges.com' target='_blank' rel='noopener noreferrer' title='www.archforges.com'>
            Arch Forge Solutions
          </a>
        </div>
      </div>
    </>
  );
};

export default Footer;
